package one.devsbox.www.tools

data class ArgsId(var id: Long = -1)
